import React, { createContext, useContext, useMemo, useState } from 'react';
import { FlexibleDatesProps } from '@components/Results/Components/FlexibleDates/RoundTrip/Grid/FlexibleDatesGrid';

type SelectedCellContextType = {
  selectedCell: FlexibleDatesProps | null;
  setSelectedCell: (columnData) => void;
  hoveredCell: FlexibleDatesProps | null;
  setHoveredCell: (columnData) => void;
  isModalOpen: boolean;
  setIsModalOpen: (open: boolean) => void;
};

const FlexibleDatesRoundTripContext = createContext<SelectedCellContextType>(
  {} as SelectedCellContextType
);

export const FlexibleDatesRoundTripProvider: React.FC = ({ children }) => {
  const [selectedCell, setSelectedCell] = useState(null);
  const [hoveredCell, setHoveredCell] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const value = useMemo(
    () => ({
      selectedCell,
      setSelectedCell,
      hoveredCell,
      setHoveredCell,
      isModalOpen,
      setIsModalOpen,
    }),
    [isModalOpen, selectedCell, hoveredCell]
  );

  return (
    <FlexibleDatesRoundTripContext.Provider value={value}>
      {children}
    </FlexibleDatesRoundTripContext.Provider>
  );
};

export const useFlexibleDatesRoundTrip = (): SelectedCellContextType => {
  return useContext(FlexibleDatesRoundTripContext);
};
